import { useCallback, useEffect, useMemo, useState } from 'react';
import Layout from 'components/layouts';
import PageTitle from 'components/organisms/PageTitle';
import FormFooter from 'components/molecules/FormFooter';
import { useServiceForm } from 'hooks/formStates/settings';
import routeCodes from 'common/constants/route-codes';
import { useCommon } from 'redux/common/use-common';
import UIHelper from 'services/UIHelper';
import { useHistory, useParams } from 'react-router-dom';
import ServicesApi from 'libs/api/services';
import ServiceForm from 'components/molecules/settings/v2/ServiceForm';
import { nanoid } from 'nanoid';
import RouterHelper from 'services/RouterHelper';
import { useUser } from 'redux/user/use-user';
import { Header, HeaderTitle } from 'components/organisms/SettingsForm/styled';
import { StyledFormBlockWrapper } from 'components/atoms/Wrappers';

const SettingsV2ServiceCreate = ({ history }) => {
  const [localUpdateInProcess, setLocalUpdateInProcess] = useState(false);
  const [inProcess, setInProcess] = useState(false);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const { isSuperAdmin } = useUser();

  const onCancel = useCallback(() => {
    history.push(
      isSuperAdmin
        ? RouterHelper.getRouteWithRestaurant(routeCodes.superAdmin.settings)
        : routeCodes.settings,
    );
  }, [history, isSuperAdmin]);

  const {
    localState,
    onSelectTime,
    onChange,
    onClickChip,
    onChangeServiceRoom,
    onChangeRoomsCount,
    onClickRoomsCount,
    onChangeRoomItem,
    errors,
    setErrors,
    rooms,
    onChangeRoom,
    onClickAddRoom,
    setLocalState,
    onDeleteException,
  } = useServiceForm(true);

  const { currentRestaurant } = useCommon();

  const api = useMemo(() => {
    return new ServicesApi(currentRestaurant?.id);
  }, [currentRestaurant]);

  const onSubmit = useCallback(async () => {
    setInProcess(true);
    try {
      await api.put(id, {
        data: {
          service:{
            ...localState,
          }
        },
      });
      UIHelper.showSuccessMessage();
      history.push(
        isSuperAdmin
          ? RouterHelper.getRouteWithRestaurant(
              routeCodes.superAdmin.settings,
            )
          : routeCodes.settings,
      );
    } catch (e) {
      setErrors(e?.response?.data);
    } finally {
      setInProcess(false);
    }
  }, [
    id,
    api,
    isSuperAdmin,
    localState,
    history,
  ]);

  useEffect(() => {
    if (!currentRestaurant?.id) return;
    const currentlyApi = new ServicesApi(currentRestaurant.id);
    (async () => {
      try {
        console.log('Fetching service data for ID:', id);
        const {
          data: {
            service: { service_opening_hours, services_rooms, ...rest },
          },
        } = await currentlyApi.get(id);
        
        console.log('Raw service data from API:', {
          service_opening_hours,
          services_rooms,
          ...rest
        });
        
        const formattedData = {
          ...rest,
          service_opening_hours_attributes: service_opening_hours,
          services_rooms_attributes: [
            ...(services_rooms || []),
            {
              room_id: '',
              total_seats: '',
              uuid: nanoid(),
            },
          ],
        };
        
        console.log('Formatted data for form:', formattedData);
        
        setLocalState(formattedData);
      } catch (e) {
        console.error('Error fetching service data:', e);
      } finally {
        setLoading(false);
      }
    })();
  }, [id, currentRestaurant]);

  return (
    <Layout>
      <Header>
        <HeaderTitle>Modifica Servizio</HeaderTitle>
      </Header>
      <StyledFormBlockWrapper desktopMl={0} style={{ paddingTop: '30px' }}>
        {loading ? (
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '200px',
            fontSize: '16px',
            color: '#666'
          }}>
            Caricamento dati del servizio...
          </div>
        ) : ( 
          <ServiceForm
            rooms={rooms}
            onChangeRoom={onChangeRoom}
            localState={localState}
            onSelectTime={onSelectTime}
            onChange={onChange}
            onClickChip={onClickChip}
            onChangeServiceRoom={onChangeServiceRoom}
            onChangeRoomsCount={onChangeRoomsCount}
            onClickRoomsCount={onClickRoomsCount}
            onChangeRoomItem={onChangeRoomItem}
            onClickAddRoom={onClickAddRoom}
            errors={errors}
            isEditMode={true}
          />
        )}
      </StyledFormBlockWrapper>
      <FormFooter
        mobPadding='20px'
        style={{ marginTop: 0 }}
        isForm={true}
        hideCancel={false}
        submitText='Salva modifiche'
        cancelText='Annulla'
        onSave={onSubmit}
        onCancel={onCancel}
        inProcess={inProcess}
      />
    </Layout>
  );
};

export default SettingsV2ServiceCreate;
